import React, { Component } from 'react';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';
import JssProvider from 'react-jss/lib/JssProvider';
import preset from 'jss-preset-default';
import { create, SheetsRegistry } from 'jss';
// import { Provider } from 'react-redux';
// import store from './store';
// import ApolloClient from 'apollo-boost';
import { ApolloProvider } from 'react-apollo';
import { clientURI } from './libraries/clientURI';

// import gql from 'graphql-tag';

import RouterSwitch from './pages/RouterSwitch';
import LoginPage from './pages/LoginPage';
import Header from './components/Header';
import session from './models/Session';

// const client = new ApolloClient({
//   uri: 'http://tm-graphql.streamframe.biz/graphql',
// });

const sheetsRegistry = new SheetsRegistry();

const jss = create(preset());
jss.options.insertionPoint = document.getElementById('jss-insertion-point');

const styles = {
  appContainer: {
    backgroundColor: '#f2f3f1',
    // height: '100%',
    minHeight: '100vh',
    paddingBottom: '100px',
  },
};

// // Fetch GraphQL data with plain JS
// client
//   .query({
//     query: gql`
//       {
//         userMany {
//           name {
//             last,
//             first
//           }
//         }
//       }
//     `
//   })
//   .then(result => console.log(result));

class App extends Component {
  state = {
    user: null, 
  }

  constructor(props) {
    super(props);
    this.getSession();
  }


  async getSession() {
    await session.fetchLocal();
    const user = session.getUser();

    console.log('getSession', user);
    if (user._id) {
      this.setState({
        user: user
      }, () => this.checkRoute());
    }
  }

  checkRoute() {
    if (!session.getUser()._id) {
      if (!/login/.test(window.location.pathname)) {
        window.location.replace("/login?redirect=" + encodeURIComponent(window.location.pathname));
      }
    } else {
      if (/redirect/.test(window.location.search)) {
        window.location.replace(decodeURIComponent(window.location.search.replace('?redirect=','')));
      } else if (/login/.test(window.location.pathname)) {
        window.location.replace("/login?redirect=/");
      } 
      // if (window.location.pathname !== '/') {
      //   window.location.replace('/');  
      // }       
     }
  }

  handleLogin = (user) => {
    console.log('Handle login', user);

    session.setUser(user);
    this.setState({
      user,
    }, () => this.checkRoute());
  }

  render() {
    const { classes } = this.props;
    return (
      <ApolloProvider client={clientURI}>
        <JssProvider jss={jss} registry={sheetsRegistry} >
          { !this.state.user? (<LoginPage handleLogin={this.handleLogin} />) : (
            <div className={classes.appContainer}>
              <Header />
              <RouterSwitch />
            </div>
          )}
        </JssProvider>
      </ApolloProvider>
    );
  }
}

// class App extends Component {
//   render() {
//     const { classes } = this.props;
//     return (
//       <Provider store ={store}>
//         <JssProvider jss={jss} registry={sheetsRegistry} >
//           <div className={classes.appContainer}>
//             <Header />
//             <RouterSwitch />
//           </div>
//         </JssProvider>
//       </Provider>
//     );
//   }
// }

App.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default injectSheet(styles)(App);



// WEBPACK FOOTER //
// ./src/App.js